import { ExtractProduct, ExtractProductSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";

export type CreateProductRequest = {
	name: string;
	categorie: string;
	marque: string;
	fournisseur: string;
};

type CreateProductResponse = {
	newProduct: ExtractProduct;
}

export const createProduct = createAppAsyncThunk<CreateProductResponse, CreateProductRequest>(
	"createProduct",
	async (data, { extra }) => {
		const newProduct = await extra.etlClient.create(ExtractProductSchema, data);
		return {
			newProduct: newProduct.data
		};
	}
);
